import { TomatoState } from '@/components/MissionUncrossable/Board/Streets/Street/Tomato/props';
import { RootState } from '@/lib/store';
import { getMissionUncrossableAnimationDuration } from '@/utils/missionUncrossable/getMissionUncrossableAnimationDuration';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UseTomatoSprintProps } from './props';

export function useTomatoSprint({ death, walk, win }: UseTomatoSprintProps) {
  const [tomatoState, setTomatoState] = useState<TomatoState>(
    TomatoState.Iddle,
  );
  const dificulty: bigint = useSelector(
    (state: RootState) => state.gamePreferences.difficultyId,
  );
  const timeoutTomatoDeath = getMissionUncrossableAnimationDuration(
    dificulty as any,
  );

  function handleTomatoState() {
    if (death) {
      setTimeout(() => {
        setTomatoState(TomatoState.Death);
      }, timeoutTomatoDeath / 8);
      return;
    }

    if (win) {
      setTomatoState(TomatoState.Win);
      return;
    }

    if (!walk) {
      setTomatoState(TomatoState.Iddle);
      return;
    }

    let current = TomatoState.Walk1;
    setTomatoState(current);

    const interval = setInterval(() => {
      current =
        current === TomatoState.Walk1 ? TomatoState.Walk2 : TomatoState.Walk1;
      setTomatoState(current);
    }, 200);

    return () => clearInterval(interval);
  }

  useEffect(handleTomatoState, [death, walk, win, timeoutTomatoDeath]);

  const getTomatoPosition = useCallback(() => {
    switch (tomatoState) {
      case TomatoState.Iddle:
        return '0px 0';
      case TomatoState.Walk1:
        return '-82px 0';
      case TomatoState.Walk2:
        return '-170px 0';
      case TomatoState.Win:
        return '-248px 0';
      case TomatoState.Death:
        return '-336px 0';
    }
  }, [tomatoState]);

  const position = getTomatoPosition();

  return position;
}
